// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"551da8c6","832":"8a2d9d0c"}[chunkId] + ".chunk.js";
};